import { handleActions } from 'redux-actions'
import * as actions from './actions'

const reducerKey = 'shared'

const initialState = {
  braintreeNonce: null,
}

const reducer = handleActions(
  {
    [actions.setBraintreeNonce]: 
      (state, {payload}) => ({ braintreeNonce: payload}),
    [actions.clearBraintreeNonce]: 
      () => ({ braintreeNonce: null }),
  },
  initialState
)

export { reducer, reducerKey }
